import { render, staticRenderFns } from "./VLCard.vue?vue&type=template&id=7f0ff24d&scoped=true"
import script from "./VLCard.vue?vue&type=script&lang=js"
export * from "./VLCard.vue?vue&type=script&lang=js"
import style0 from "./VLCard.vue?vue&type=style&index=0&id=7f0ff24d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0ff24d",
  null
  
)

export default component.exports